export enum MappingType{
    POS = 1,
    PaperPackaging = 2
}